export const inputFieldStyles = `
  h-[38px] w-full rounded-md focus:outline-none pl-4 bg-transparent text-[14px] border border-[#E2E8F0] focus:border-[#020817]
`;

export const inputLabelStyles = `
  text-[14px] text-[#020817] font-medium mb-2 inline-block
`;

export const textareaStyles = `
  w-full rounded-md focus:outline-none p-3 bg-transparent text-[14px] border border-[#E2E8F0] focus:border-[#020817] resize-none
`;